import { Alert, AlertTitle } from "@mui/material";
import localisations from "../../localisation";

function FileImportValidPane() {
    const { title, description } = localisations.fileImportValidPane;

    return (
        <Alert severity="success">
            <AlertTitle>{title}</AlertTitle>
            {description}
        </Alert>
    );
}

export default FileImportValidPane;
